import { useState, useEffect, useMemo } from "react";
import csv from 'csvtojson';
import "./App.css";

import EicCodeBlock from "./EicCodeBlock";
import Select from "react-select";

// const selectOptions = [
//   "ControlArea",
//   "BiddingZone",
//   "ControlBlock",
//   "MarketArea",
//   "MarketBalanceArea",
//   "MemberState",
//   "SchedulingArea",
//   "Valid EIC Function needed",
// ];

function selectOptions(areacodes) {

  return new Set([
    ...areacodes
      .filter((a) => a.EicTypeFunctionList)
      .map((a) => {
        const { EicTypeFunctionList } = a;
        // console.log(EicTypeFunctionList)
        if (!EicTypeFunctionList) {
          console.log("Null function");
        }
        return EicTypeFunctionList.split(", ");
      })
      .flat(),
  ]);
}

function App() {
  const [areas, setAreas] = useState([]);
  const [selectedFunction, setSelectedFunction] = useState(null);

  const filterCodesList = () => {
    // Removed in favour of function list
    // const options = areacodes.map(a => {
    //   return {
    //     value: a.EicCode, label: `${a.EicCode}  - ${a.EicDisplayName}`
    //   }
    // })

    const options = [...selectOptions(areas)].map((o) => {
      return {
        value: o,
        label: o,
      };
    });

    return <Select isClearable={true} value={selectedFunction} options={options} onChange={onChange} />;
  };

  useEffect(()=> {
    fetch('https://eepublicdownloads.entsoe.eu/eic-codes-csv/Y_eiccodes.csv')
      .then((res) => {
        return res.text();
      }).then((data) => {
        return csv().fromString(data);
      }).then((json) => {
        setAreas(json);
      });
  }, []);

  const onChange = option => {
    setSelectedFunction(option);
  }


  const filteredAreas = useMemo(()=> {
    if (selectedFunction?.value) {
      const value = selectedFunction.value;

      return areas.filter((a) => a.EicTypeFunctionList).filter(a => a.EicTypeFunctionList.includes(value));
    }
    return areas;
  }, [areas, selectedFunction]);


  const areaCodesList = () => {
    return (
      <>
      <p>{`Displaying ${filteredAreas.length} areas`}</p>
      <div style={{ padding: "1rem", width: "1200px" }}>
        {filteredAreas.map((a) => {
          return <EicCodeBlock key={a.EicCode} withMap={true} code={a} />;
        })}
      </div>
      </>
    );
  };

  return (
    <div className="App">
      {filterCodesList()}
      <div
        style={{
          
          
          padding: "1rem",
        }}
      >
        {areaCodesList()}
      </div>
    </div>
  );
}

export default App;
